import { Box } from '@mui/material';
import { NodeResizer } from '@xyflow/react';
import { type FlowDecorationColor } from 'flow-schema';

import { FLOW_DECORATION_COLORS } from './constants';

interface ReactFlowDecoratorNodeResizerProps {
  selected: boolean;
  decorationColor: FlowDecorationColor;
  minWidth: number;
  minHeight: number;
}

export function ReactFlowDecoratorNodeResizer(props: ReactFlowDecoratorNodeResizerProps) {
  const { selected, decorationColor, minWidth, minHeight } = props;
  return (
    <Box
      sx={{
        '& .react-flow__resize-control.line': {
          ...FLOW_DECORATION_COLORS[decorationColor],
          opacity: 0.25,
          borderWidth: '1px',
          transition: 'ease-in-out 0.2s',
          transitionProperty: 'border-width, opacity',
          '&:hover': {
            borderWidth: '2px',
            opacity: 0.5,
          },
        },
        '& .react-flow__resize-control.handle': {
          width: selected ? 6 : 4,
          height: selected ? 6 : 4,
          ...FLOW_DECORATION_COLORS[decorationColor],
          backgroundColor: 'background.paper',
          opacity: 1,
        },
      }}
    >
      <NodeResizer minWidth={minWidth} minHeight={minHeight} />
    </Box>
  );
}
